<template lang="html">
    <div>
        <v-layout align-center justify-end row fill-height>
          <v-btn large color="success" @click="clickCreate()">Criar Album</v-btn>
        </v-layout>

        <!-- List Row -->
        <v-layout row class="mt-3">

          <v-flex v-if="isLoadingAlbums" xs12 class="text-xs-center fs-larger">
            A carregar albums
          </v-flex>

          <v-flex v-else-if="!albums || albums.length < 1" xs12 class="text-xs-center fs-larger">
            Sem albums
          </v-flex>

          <v-flex v-else xs12>

            <v-card>
              <v-list two-line>

                <template v-for="(album, index) in albums" :keys="index">
                  <!-- <v-subheader
                    v-if="item.header"
                    :key="item.header"
                  >
                    {{ item.header }}
                  </v-subheader> -->

                  <!-- <v-divider
                    v-else-if="item.divider"
                    :key="index"
                    :inset="item.inset"
                  ></v-divider> -->

                  <v-list-tile
                    :key="album.id"
                    avatar
                    @click="openAlbum(album, 'pt')"
                  >
                    <v-list-tile-avatar color="grey">
                      <img :src="album.cover_image">
                    </v-list-tile-avatar>

                    <v-list-tile-content>

                      <v-layout w-100 align-center>
                        <!-- Left -->
                        <v-flex grow>
                          <v-list-tile-title v-html="album.title"></v-list-tile-title>
                          <v-list-tile-sub-title v-html="album.author"></v-list-tile-sub-title>
                        </v-flex>
                        <!-- Right -->
                        <v-flex shrink>
                          <v-layout row>
                            <div @click="openAlbum(album, 'en')" class="mr-2">EN</div>
                            <div @click="openAlbum(album, 'es')">ES</div>
                          </v-layout>
                        </v-flex>
                      </v-layout>

                    </v-list-tile-content>
                  </v-list-tile>

                </template>
              </v-list>
            </v-card>

          </v-flex>
        </v-layout>

    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default {
  created: function () {
    this.getAlbums();
  },
  data: function () {
    return {
      isLoadingAlbums: false
    }
  },
  methods:{
    ...mapActions([
      'downloadAlbums'
    ]),
    getAlbums: function () {
      this.isLoadingAlbums = true
      this.downloadAlbums().then(()=>{
        this.isLoadingAlbums = false
      })
    },
    clickCreate: function () {
      this.$router.push({name:'AlbumCreate'})
    },
    openAlbum: function (album, lang) {
      this.$router.push({ name: 'AlbumView', params: { albumId: album.id, language: lang } })
    }
  },
  computed: {
    ...mapGetters([
      'getDownloadedAlbums'
    ]),
    albums: function () {
      return this.getDownloadedAlbums
    }
  },
}
</script>

<style lang="css" scoped>
</style>
